<template>
  <svg :class="iconClass">
    <use :xlink:href="`#icon-${name}`" />
  </svg>
</template>

<script>
import 'assets/icons'

export default {
  name: 'Icon',
  props: {
    name: {
      type: String,
      required: true
    },
    spin: Boolean,
    cursor: Boolean
  },
  computed: {
    iconClass() {
      return [
        'icon',
        'icon-' + this.name,
        this.spin && 'spinner',
        this.cursor && 'cursor'
      ]
    }
  }
}
</script>
<style lang="less" scoped>
svg {
  display: inline-block;
  width: 14px;
  height: 14px;
  fill: currentColor;
  vertical-align: middle;
  outline: none;

  &.cursor {
    cursor: pointer;
  }
}
</style>
